export const DISBURSEMENT_LIST_REQUEST = "DISBURSEMENT_LIST_REQUEST";
export const DISBURSEMENT_LIST_SUCCESS = "DISBURSEMENT_LIST_SUCCESS";
export const DISBURSEMENT_LIST_FAIL = "DISBURSEMENT_LIST_FAIL";

export const DISBURSEMENT_CREATE_REQUEST = "DISBURSEMENT_CREATE_REQUEST";
export const DISBURSEMENT_CREATE_SUCCESS = "DISBURSEMENT_CREATE_SUCCESS";
export const DISBURSEMENT_CREATE_FAIL = "DISBURSEMENT_CREATE_FAIL";
export const DISBURSEMENT_CREATE_RESET = "DISBURSEMENT_CREATE_RESET";

export const DISBURSEMENT_DETAILS_REQUEST = "DISBURSEMENT_DETAILS_REQUEST";
export const DISBURSEMENT_DETAILS_SUCCESS = "DISBURSEMENT_DETAILS_SUCCESS";
export const DISBURSEMENT_DETAILS_FAIL = "DISBURSEMENT_DETAILS_FAIL";

export const DISBURSEMENT_UPDATE_REQUEST = "DISBURSEMENT_UPDATE_REQUEST";
export const DISBURSEMENT_UPDATE_SUCCESS = "DISBURSEMENT_UPDATE_SUCCESS";
export const DISBURSEMENT_UPDATE_FAIL = "DISBURSEMENT_UPDATE_FAIL";
export const DISBURSEMENT_UPDATE_RESET = "DISBURSEMENT_UPDATE_RESET";

export const DISBURSEMENT_DELETE_REQUEST = "DISBURSEMENT_DELETE_REQUEST";
export const DISBURSEMENT_DELETE_SUCCESS = "DISBURSEMENT_DELETE_SUCCESS";
export const DISBURSEMENT_DELETE_FAIL = "DISBURSEMENT_DELETE_FAIL";
export const DISBURSEMENT_DELETE_RESET = "DISBURSEMENT_DELETE_RESET";